import { render } from "./HelpCardComponent.vue?vue&type=template&id=4d789d3f"
import script from "./HelpCardComponent.vue?vue&type=script&lang=js"
export * from "./HelpCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__